var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"app-form-text"},[_vm._t("default"),_c('input',_vm._b({attrs:{"type":"text"},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},'input',_vm.$attrs,false))],2)}
var staticRenderFns = []

export { render, staticRenderFns }